(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ferox-collection-controls"]) return;
  try {
    
if (!customElements.get('ferox-collection-controls')) { customElements.define('ferox-collection-controls', class extends HTMLElement {
  connectedCallback(){if(this.ready)return;this.ready=true;this.querySelectorAll('[data-open]').forEach(t=>t.addEventListener('click',()=>this.open(t.dataset.open,t)));this.querySelectorAll('[data-close]').forEach(b=>b.addEventListener('click',()=>this.close(b.closest('dialog'))));this.querySelectorAll('dialog').forEach(d=>{d.addEventListener('click',e=>{if(e.target===d)this.close(d)});d.addEventListener('close',()=>d.returnFocus&&d.returnFocus.focus())});this.form=this.querySelector('[data-filter-form]');this.count=this.querySelector('[data-result-count]');this.form.addEventListener('input',()=>this.updateCount())}
  open(name,trigger){const d=this.querySelector('[data-drawer="'+name+'"]');if(!d)return;d.returnFocus=trigger;d.showModal();d.querySelector('[data-close]').focus()}
  close(d){if(d&&d.open)d.close()}
  updateCount(){clearTimeout(this.timer);this.timer=setTimeout(async()=>{const params=new URLSearchParams(new FormData(this.form));const r=await fetch(location.pathname+'?section_id='+this.dataset.sectionId+'&'+params);if(!r.ok)return;const n=new DOMParser().parseFromString(await r.text(),'text/html').querySelector('[data-result-count]');if(n&&this.count)this.count.textContent=n.textContent},250)}
})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ferox-ride-bundle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ferox-ride-bundle')) {
    customElements.define('ferox-ride-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.productForm = document.getElementById(this.dataset.productFormId);
        this.bindEvents();
        this.bindProductPurchase();
        this.updateTotal();
      }

      disconnectedCallback() {
        if (!this.productForm) return;
        this.productForm.removeEventListener('click', this.onProductButtonClick, true);
        this.productForm.removeEventListener('submit', this.onProductFormSubmit, true);
      }

      bindEvents() {
        this.addEventListener('change', (event) => {
          if (event.target.matches('.ferox-bundle__toggle')) {
            const card = event.target.closest('.ferox-bundle__card');
            card.querySelector('.ferox-bundle__quantity').hidden = !event.target.checked;
            this.updateTotal();
          }
          if (event.target.matches('.ferox-bundle__variant')) {
            const card = event.target.closest('.ferox-bundle__card');
            const option = event.target.selectedOptions[0];
            card.dataset.variantId = option.value;
            card.dataset.price = option.dataset.price;
            card.querySelector('.ferox-bundle__price').textContent = this.formatMoney(Number(option.dataset.price));
            this.updateTotal();
          }
          if (event.target.matches('.ferox-bundle__quantity input')) {
            event.target.value = Math.max(1, Number(event.target.value) || 1);
            this.updateTotal();
          }
        });

        this.addEventListener('click', (event) => {
          const quantityButton = event.target.closest('[data-quantity-action]');
          if (!quantityButton) return;
          const input = quantityButton.closest('.ferox-bundle__quantity').querySelector('input');
          const current = Math.max(1, Number(input.value) || 1);
          input.value = quantityButton.dataset.quantityAction === 'increase' ? current + 1 : Math.max(1, current - 1);
          this.updateTotal();
        });
      }

      bindProductPurchase() {
        if (!this.productForm) return;
        this.onProductButtonClick = (event) => {
          const button = event.target.closest('gp-product-button button[name="add"], button.add-to-cart-btn');
          if (!button || !this.productForm.contains(button)) return;
          this.addProductAndAccessories(event);
        };
        this.onProductFormSubmit = (event) => this.addProductAndAccessories(event);
        this.productForm.addEventListener('click', this.onProductButtonClick, true);
        this.productForm.addEventListener('submit', this.onProductFormSubmit, true);
      }

      getSelectedCards() {
        return Array.from(this.querySelectorAll('.ferox-bundle__card')).filter((card) => card.querySelector('.ferox-bundle__toggle').checked);
      }

      updateTotal() {
        const total = this.getSelectedCards().reduce((sum, card) => {
          const quantity = Math.max(1, Number(card.querySelector('.ferox-bundle__quantity input').value) || 1);
          return sum + Number(card.dataset.price) * quantity;
        }, 0);
        this.querySelector('.ferox-bundle__total strong').textContent = this.formatMoney(total);
      }

      formatMoney(cents) {
        return new Intl.NumberFormat(undefined, {style: 'currency', currency: this.dataset.currency || 'USD'}).format(cents / 100);
      }

      productLineItem() {
        const formData = new FormData(this.productForm);
        const variantId = formData.get('id');
        if (!variantId) return null;
        const item = {id: variantId, quantity: Math.max(1, Number(formData.get('quantity')) || 1)};
        const sellingPlan = formData.get('selling_plan');
        if (sellingPlan) item.selling_plan = sellingPlan;
        const properties = {};
        for (const [name, value] of formData.entries()) {
          if (!name.startsWith('properties[') || !name.endsWith(']')) continue;
          const key = name.slice(11, -1);
          if (key) properties[key] = value;
        }
        if (Object.keys(properties).length) item.properties = properties;
        return item;
      }

      addProductAndAccessories(event) {
        const selectedCards = this.getSelectedCards();
        if (!selectedCards.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (this.isAdding) return;
        const productItem = this.productLineItem();
        if (!productItem) return;
        this.addAllItems(productItem, selectedCards);
      }

      async addAllItems(productItem, selectedCards) {
        this.isAdding = true;
        const status = this.querySelector('.ferox-bundle__status');
        const items = [productItem].concat(selectedCards.map((card) => ({
          id: card.dataset.variantId,
          quantity: Math.max(1, Number(card.querySelector('.ferox-bundle__quantity input').value) || 1)
        })));
        status.textContent = '';
        try {
          const response = await fetch(this.dataset.addUrl, {
            method: 'POST',
            headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
            body: JSON.stringify({items})
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.dataset.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          status.textContent = this.dataset.error;
        } finally {
          this.isAdding = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ferox-storefront-polish"]) return;
  try {
    
  const feroxPolishRoot = document.querySelector('.ferox-storefront-polish');

  function closeFeroxSortDrawer() {
    const overlay = document.querySelector('.ferox-sort-overlay');
    if (overlay) overlay.classList.remove('is-open');
    document.documentElement.classList.remove('ferox-sort-open');
  }

  function buildFeroxSortDrawer(select, trigger, root) {
    let overlay = document.querySelector('.ferox-sort-overlay');
    if (overlay) overlay.remove();

    overlay = document.createElement('div');
    overlay.className = 'ferox-sort-overlay';
    overlay.innerHTML = '<aside class="ferox-sort-drawer" role="dialog" aria-modal="true" aria-label="' + root.dataset.sortTitle + '"><div class="ferox-sort-header"><h2 class="ferox-sort-title">' + root.dataset.sortTitle + '</h2><button type="button" class="ferox-sort-close" aria-label="' + root.dataset.sortTitle + '">×</button></div><div class="ferox-sort-options"></div><button type="button" class="ferox-sort-submit">' + root.dataset.sortSubmitLabel + '</button></aside>';
    const optionHost = overlay.querySelector('.ferox-sort-options');

    const supportedSortValues = ['manual', 'most-relevant', 'title-ascending', 'title-descending', 'price-ascending', 'price-descending'];
    Array.from(select.options).filter((option) => supportedSortValues.includes(option.value)).forEach((option) => {
      const label = document.createElement('label');
      label.className = 'ferox-sort-option';
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'ferox-sort';
      radio.value = option.value;
      radio.checked = option.selected;
      const text = document.createElement('span');
      text.textContent = option.textContent.trim();
      label.append(radio, text);
      optionHost.append(label);
    });

    overlay.querySelector('.ferox-sort-close').addEventListener('click', closeFeroxSortDrawer);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) closeFeroxSortDrawer();
    });
    overlay.querySelector('.ferox-sort-submit').addEventListener('click', () => {
      const selected = overlay.querySelector('input[name="ferox-sort"]:checked');
      if (!selected) return;
      select.value = selected.value;
      const sourceOption = select.options[select.selectedIndex];
      trigger.textContent = root.dataset.sortButtonLabel + ': ' + sourceOption.textContent.trim();
      closeFeroxSortDrawer();
      select.dispatchEvent(new Event('change', {bubbles: true}));
    });
    document.body.append(overlay);
    return overlay;
  }

  function initializeFeroxCollectionControls() {
    const root = feroxPolishRoot;
    root.dataset.sortTitle = root.dataset.sortSubmitLabel;
    root.dataset.sortButtonLabel = root.dataset.sortLabel.replace(/:\s*$/, '');
    const facets = document.querySelector('.facets-container');
    if (!root || !facets || facets.querySelector('.ferox-collection-controls')) return;

    const nativeFilterSummary = facets.querySelector('menu-drawer.mobile-facets__wrapper > details > summary');
    const sortSelect = facets.querySelector('select[name="sort_by"]');
    if (!nativeFilterSummary || !sortSelect) return;

    nativeFilterSummary.classList.add('ferox-native-filter-source');
    const nativeSortSource = sortSelect.closest('facet-filters-form, .facets');
    if (nativeSortSource) nativeSortSource.classList.add('ferox-native-sort-source');

    const controls = document.createElement('div');
    controls.className = 'ferox-collection-controls';

    const filterButton = document.createElement('button');
    filterButton.type = 'button';
    filterButton.className = 'ferox-collection-control';
    filterButton.textContent = root.dataset.filterLabel;
    filterButton.addEventListener('click', () => nativeFilterSummary.click());

    const sortButton = document.createElement('button');
    sortButton.type = 'button';
    sortButton.className = 'ferox-collection-control';
    sortButton.textContent = root.dataset.sortButtonLabel + ': ' + sortSelect.options[sortSelect.selectedIndex].textContent.trim();
    sortButton.addEventListener('click', () => {
      const overlay = buildFeroxSortDrawer(sortSelect, sortButton, root);
      overlay.classList.add('is-open');
      document.documentElement.classList.add('ferox-sort-open');
      overlay.querySelector('input:checked')?.focus();
    });

    controls.append(filterButton, sortButton);
    facets.prepend(controls);
  }

  function bootFeroxStorefrontPolish() {
    initializeFeroxCollectionControls();
    const observer = new MutationObserver(() => initializeFeroxCollectionControls());
    observer.observe(document.getElementById('MainContent') || document.body, {childList: true, subtree: true});
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeFeroxSortDrawer();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootFeroxStorefrontPolish, {once: true});
  } else {
    bootFeroxStorefrontPolish();
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
